import { render, staticRenderFns } from "./PagePalette.vue?vue&type=template&id=26a8acf3&scoped=true&"
import script from "./PagePalette.vue?vue&type=script&lang=js&"
export * from "./PagePalette.vue?vue&type=script&lang=js&"
import style0 from "./PagePalette.vue?vue&type=style&index=0&id=26a8acf3&prod&lang=scss&scoped=true&"
import style1 from "./PagePalette.vue?vue&type=style&index=1&id=26a8acf3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a8acf3",
  null
  
)

export default component.exports